/* src/app/main/not-found/not-found.component.css */
.nofound-bg-img {
  background-position: center;
  background-size: cover;
  height: 300px;
}
.nofound-bg-img .nofound-icon {
  width: 15%;
  margin-right: 10px;
}
.nofound-bg-img h3 {
  font-size: 65px;
}
.nofound-bg-img p {
  font-size: 20px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.home-cta {
  background-color: #E8882D;
  border: none;
  border-radius: 4px;
  font-family: "D-DIN-Bold";
  padding: 5px 36px;
}
@media (max-width: 767px) {
  .nofound-bg-img p {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media (device-width: 1280px) {
  .nofound-bg-img {
    height: 425px;
  }
}
@media (device-width: 1280px) and (device-height: 950px) {
  .nofound-bg-img {
    height: 575px;
  }
}
@media (device-width: 1440px) {
  .nofound-bg-img {
    height: 497px;
  }
}
@media (device-width: 1600px) {
  .nofound-bg-img {
    height: 465px;
  }
}
@media (min-width: 1680px) {
  .nofound-bg-img .nofound-icon {
    width: 20%;
  }
  .nofound-bg-img h3 {
    font-size: 80px;
  }
  .nofound-bg-img p {
    font-size: 24px;
  }
  .home-cta {
    font-size: 22px;
  }
}
@media (device-width: 1680px) {
  .nofound-bg-img {
    height: 615px;
  }
  .nofound-bg-img .nofound-icon {
    width: 20%;
  }
  .nofound-bg-img h3 {
    font-size: 80px;
  }
  .nofound-bg-img p {
    font-size: 24px;
  }
  .home-cta {
    font-size: 22px;
  }
}
@media (device-width: 1920px) {
  .nofound-bg-img {
    height: 645px;
  }
}
/*# sourceMappingURL=not-found.component.css.map */
